// extracted by css-extract-rspack-plugin
export default {"root":"root-g3smba text-sm-medium","filterText":"filterText-EKTODd"};